@file:OptIn(InternalResourceApi::class)

package webproject.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/webproject.composeapp.generated.resources/"

internal val Res.font.font_cai: FontResource by lazy {
      FontResource("font:font_cai", setOf(
        ResourceItem(setOf(), "${MD}font/font_cai.ttf", -1, -1),
      ))
    }

internal val Res.font.font_song: FontResource by lazy {
      FontResource("font:font_song", setOf(
        ResourceItem(setOf(), "${MD}font/font_song.otf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("font_cai", Res.font.font_cai)
  map.put("font_song", Res.font.font_song)
}
